import { render, staticRenderFns } from "./BelowQuickSearch.vue?vue&type=template&id=60670c6e"
import script from "./BelowQuickSearch.vue?vue&type=script&lang=js"
export * from "./BelowQuickSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports